export const AppRoutes = {
  BASE: '/',
  SECURITY_FRAME_LOADER: '/seed-phrase',
  SECURITY_FRAME: {
    BASE: '/security-frame',
    THINKING: '/security-frame/thinking',
  },
  SCANNING: '/:fingerprint/scanning',
  ENTER_WALLET_ADDRESSES: '/:fingerprint/enter-wallet-addresses',
  REVIEW: '/:fingerprint/review',
  BROADCASTING: '/:fingerprint/broadcasting',
  STATUS: '/:fingerprint/status',
  BASENAME: '/',
} as const;
